<tui-pagination
  [index]="currentPage - 1"
  [length]="numberOfPages"
  (indexChange)="currentPageChange.emit($event + 1)"
  [sidePadding]="1"
  [activePadding]="1"
></tui-pagination>
